 <template>
    <div class="task-content">
        <!-- 头部搜索和导出按钮 -->
        <div class="task-content-header">
            <SearchControl :searchWidth="388" placeholder="搜索站点编号/钻孔ID/行政区划" @searchAction="searchAction"></SearchControl>
            <div class="task-content-header-btn">
                <button @click="deleteDrill" :disabled="!selectedTaskArray || selectedTaskArray.length == 0" :class="{ disabled: !selectedTaskArray || selectedTaskArray.length == 0 }">删除</button>
                <DownloadExcel
                    :data="selectedTaskArray"
                    :export-fields="fieldsObj"
                    name="钻孔数据.xls"
                >
                    <button :disabled="!selectedTaskArray || selectedTaskArray.length == 0" :class="{ disabled: !selectedTaskArray || selectedTaskArray.length == 0 }" style="margin: 0 12px;">导出</button>
                </DownloadExcel>
                <div class="add-task">新增任务
                    <input ref="uploadInput" class="file-ele" type="file" accesskey=".xlsx,.xls" @change="uploadDrillFile">
                </div>
            </div>
        </div>
        <!-- 列表 -->
        <div class="task-list gq-table">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :border="true"
                :row-key="getRowKey"
                @selection-change="handleSelectionChange"
                @cell-click="clickItem"
            >
                <el-table-column
                    type="selection"
                    width="42"
                    fixed="left"
                    :reserve-selection="true"
                >
                </el-table-column>
                <!-- 站点编号 -->
                <el-table-column
                    label="站点编号"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zdId }}</div>
                            <span class="single-show">{{ scope.row.zdId }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 站点名称 -->
                <el-table-column
                    label="站点名称"
                    width="90"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zdName }}</div>
                            <span class="single-show">{{ scope.row.zdName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔ID -->
                <el-table-column
                    label="钻孔ID"
                    width="80"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.zkId }}</div>
                            <span class="single-show">{{ scope.row.zkId }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 行政区划 -->
                <el-table-column
                    label="行政区划"
                    width="206"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.province + scope.row.city + scope.row.county + scope.row.town }}</div>
                            <span class="single-show">{{ scope.row.province + scope.row.city + scope.row.county + scope.row.town }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔勘察经度 -->
                <el-table-column
                    label="钻孔勘察经度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.planLon }}</div>
                            <span class="single-show">{{ scope.row.planLon }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 钻孔勘察纬度 -->
                <el-table-column
                    label="钻孔勘察纬度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.planLat }}</div>
                            <span class="single-show">{{ scope.row.planLat }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 实际开孔经度 -->
                <!-- <el-table-column
                    label="实际开孔经度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.phoneLon }}</div>
                            <span class="single-show">{{ scope.row.phoneLon }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
                <!-- 实际开孔纬度 -->
                <!-- <el-table-column
                    label="实际开孔纬度"
                    width="146"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.phoneLat }}</div>
                            <span class="single-show">{{ scope.row.phoneLat }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
                <!-- 施工队 -->
                <el-table-column
                    label="施工队"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.xgdName }}</div>
                            <span class="single-show">{{ scope.row.xgdName }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 开孔日期 -->
                <el-table-column
                    label="开孔日期"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.startDate }}</div>
                            <span class="single-show">{{ scope.row.startDate }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 终孔日期 -->
                <el-table-column
                    label="终孔日期"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ scope.row.endDate }}</div>
                            <span class="single-show">{{ scope.row.endDate }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 任务状态 -->
                <el-table-column
                    label="任务状态"
                    width="100"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
                            <div slot="content">{{ changeStatusWordWithStatu(scope.row.status) }}</div>
                            <span class="single-show">{{ changeStatusWordWithStatu(scope.row.status) }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 报告提交时间 -->
                <el-table-column
                    label="报告提交时间"
                    width="120"
                >
                    <template slot-scope="scope">
                        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false" :disabled="!scope.row.docDate">
                            <div slot="content">{{ scope.row.docDate }}</div>
                            <span class="single-show">{{ scope.row.docDate ? scope.row.docDate : '-' }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--  -->
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
            <PaginationView :currentPage="pageNumber" :total="total"></PaginationView>
        </div>
        <DataDetail ref="dataDetail"></DataDetail>
        <ConstructionCannotDelete ref="constructionCannotDelete"></ConstructionCannotDelete>
    </div>
</template>
<script>
import PaginationView from '../../../../components/PaginationView.vue';
import SearchControl from '../../../../components/SearchControl.vue';
import DataDetail from '../../../DataManager/Components/DataDetail.vue';
import ConstructionCannotDelete from './Components/ConstructionCannotDelete.vue';
import { UploadFile, ImportDrillData, GetDrillDataList, DeleteBatchDrill } from '@/http/api/api-hb'

export default {
    props: {
        unitObj: {
            type: Object,
        }
    },
    components: { SearchControl, PaginationView, DataDetail, ConstructionCannotDelete },
    data() {
        return {
            // 搜索关键字
            keywords: null,
            // 选中的任务数组
            selectedTaskArray: [],
            fieldsObj: {
                '站点编号': 'zdId',
                '站点名称': 'zdName',
                '钻孔ID': 'zkId',
                '行政区划': 'address',
                '钻孔勘查经度': 'planLon',
                '钻孔勘查纬度': 'planLat',
                '施工队': 'xgdName',
                '开孔日期': 'startDate',
                '终孔日期': 'endDate',
                '任务状态': 'statusValue',
                '报告提交时间': 'docDate'
            },
            // 分页
            pageNumber: 1,
            pageSize: 10,
            // 数据列表
            tableData: [],
            // 总数
            total: 0,
        }
    },
    watch: {
        unitObj: {
            handler() {
                this.pageNumber = 1
                this.selectedTaskArray = []
                this.getDrillDataList()
            },
            depp: true
        }
    },
    mounted() {
        if (this.unitObj) {
            this.getDrillDataList()
        }
    },
    methods: {
        // 获取钻孔列表
        getDrillDataList() {
            const params = {
                xgdwId: this.unitObj.id,
                current: this.pageNumber,
                limit: this.pageSize,
                keyword: this.keywords
            }
            GetDrillDataList(params).then(res => {
                if (res.code == 200) {
                    this.total = res.data.total
                    this.tableData = res.data.rows
                } else {
                    this.$message({ type: 'warning', message: res.msg })
                }
            })
        },
        // 搜索
        searchAction(keywords) {
            this.keywords = keywords
            this.pageNumber = 1
            this.getDrillDataList()
        },
        // 分页
        paginationRequestPage(page) {
            this.pageNumber = page
            this.getDrillDataList()
        },
        // 列表单选事件
        handleSelectionChange(selection) {
            this.selectedTaskArray = selection.filter(zk => {
                zk.address = zk.province + zk.city + zk.county + zk.town
                if (zk.status == 0) {
                    zk.statusValue = '未开始'
                } else if (zk.status == 1) {
                    zk.statusValue = '施工进行中'
                } else if (zk.status == 2) {
                    zk.statusValue = '施工已完成'
                } else if (zk.status == 3) {
                    zk.statusValue = '报告已提交'
                }
                return zk
            })
        },
        // 点击一行后
        clickItem(row) {
            this.$refs.dataDetail.showDataDetail(row)
        },
        // 新增任务
        addNewTask() {

            // console.log('金华坚决和');
            // const params = {
            //     deptName: '欢哥施工队',
            //     username: "欢哥",
            //     mobile: '16600000000',
            //     pid: 2, // 创建施工单位
            // }
            // CreateUnit(params).then(res => {
            //     console.log(res);
            // })
        },
        // 选择文件上传
        uploadDrillFile(e) {
            const formData = new FormData()
            formData.append('file', e.target.files[0])
            
            UploadFile(formData).then(res => {
                if (res.code == 200) {
                    this.importDrillData(res.fileName)
                } else {
                    this.$message({ type: "warning", message: res.msg });
                }
                this.$refs["uploadInput"].value = ''
            })
        },
        // 导入钻孔数据
        importDrillData(fileName) {
            const params = {
                filePath: fileName,
                deptId: this.unitObj.id,
                deptName: this.unitObj.deptName,
            }
            ImportDrillData(params).then(res => {
                if (res.code == 200) {
                    this.$parent.updateUnitObj()
                    this.getDrillDataList()
                } else {
                    this.$message({ type: "warning", message: res.msg });
                }
            })
        },
        // 根据状态返回文字
        changeStatusWordWithStatu(statu) {
            switch (statu) {
                case 0:
                    return '未开始'
                    break;
                case 1: 
                    return '施工进行中'
                    break
                case 2:
                    return '施工已完成'
                    break
                case 3:
                    return '报告已提交'
                    break
                default:
                    break;
            }
        },
        // 判断是否包含不可删除的数据
        judgeContainUndelete() {
            let canDelete = true
            this.selectedTaskArray.forEach(task => {
                if (task.status != 0) canDelete = false
            });
            return canDelete
        },
        // 删除钻探任务
        deleteDrill() {
            if (this.judgeContainUndelete()) { // 可以删除
                if (this.selectedTaskArray.length == 0) {
                    this.$message.warning('请选择钻探任务')
                    return
                }
                this.$confirm(`确定要删除勾选任务吗？`, '温馨提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.confirmDeleteDrill()
                }).catch(() => {
                })
            } else { // 不可删除
                this.$refs.constructionCannotDelete.showDeletePrompt()
            }
        },
        // 确认删除
        confirmDeleteDrill() {
            const params = {
                ids: this.selectedIds
            }
            DeleteBatchDrill(params).then(res => {
                if (res.code == 200) {
                    this.$message.success('删除成功')
                    this.pageNumber = 1
                    this.getDrillDataList()
                    this.$parent.updateUnitObj()
                } else {
                    this.$message.warning(res.msg)
                }
             })
        },
        getRowKey(row) {
            return row.id + ''
        }
    },
    computed: {
        selectedIds() {
            let ids = []
            this.selectedTaskArray.filter(item => {
                ids.push(item.id)
                return item
            })
            return ids
        }
    },
}
</script>
<style src="../../../../assets/css/gq_table.css" scoped></style>
<style scoped>
    .task-content {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 6px;
    }
    /* 头部 */
    .task-content .task-content-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 40px);
        padding: 0 20px;
        height: 80px;
        min-width: 830px;
    }
    .task-content .task-content-header .task-content-header-btn {
        display: flex;
        align-items: center;
    }
    .task-content .task-content-header .task-content-header-btn button,
    .task-content .task-content-header .task-content-header-btn .add-task {
        width: 120px;
        height: 40px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 500;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background: #0054A0;
    }
    .task-content .task-content-header .task-content-header-btn .disabled {
        color: #CCCCCC;
        background: #F0F0F0;
    }
    /* 新增 */
    .task-content .task-content-header .task-content-header-btn .add-task {
        position: relative;
    }
    .task-content .task-content-header .task-content-header-btn .add-task .file-ele {
        position: absolute;
        top:0;
        right:0;
        opacity: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
    }
    /* 列表 */
    .task-content .task-list {
        width: calc(100% - 40px);
        height: calc(100% - 128px);
        padding: 0 20px;
    }
    /* 分页 */
    .task-content .pagination {
        width: 100%;
        height: 48px;
    }
    /* 列表 */
    /* .task-list /deep/  {

    } */
</style>